<div class="m-start-logo d-flex align-content-center flex-wrap" [ngClass]="{'animated':isAnimated}">
</div>

<div class="jumbotron py-4 m-start" [ngClass]="{'animated':isAnimated}">
  <div class="px-0 container d-flex flex-column align-items-center" [ngClass]="{'animated':isAnimated}">
    <img src="assets/app-images/logo/logo-mizrahi-mortgage-3@3x.png" class="m-logo mb-4 mb-xl-5"
      alt="{{'COMMON.LOGO_ALT' | translate}}" />
    <h1 class="app-title-xxxlarge-white text-center">{{'START.TITLE1' | translate}}</h1>
    <div>
      <p class="app-title-large mb-0 text-center">{{'START.EXPLANATION1' | translate}}</p>
    </div>
    <div>
      <p class="app-title-large-orange text-center">{{'START.EXPLANATION2' | translate}}</p>
    </div>
    <div *ngIf="explorer" class="row m-pt-5">
      <div class="pl-3">
        <button (click)="navigate('private')"
          class="mt-3 app-button button-primary btn-lg m-start-btn opacity-an transition-delay-3-5"
          [ngClass]="{'animated':isAnimated}">
          <div>{{'START.START-PRIVATE' | translate}}</div>
        </button>
      </div>
      <div>
        <button (click)="navigate('continue')"
          class="mt-3 app-button button-secondery btn-lg m-start-btn opacity-an transition-delay-3-5"
          [ngClass]="{'animated':isAnimated}">
          <div>{{'START.CONTINUE-PROCESS' | translate}}</div>
        </button>
        <button (click)="navigate('advisor')"
        class="align-self-xl-end align-self-md-center mt-3 app-button button-primary m-start-btn3"
        [ngClass]="{'animated':isAnimated}">
        <div>{{'START.START-ADVISOR'| translate}}</div>
      </button>
      </div>
    </div>

    <div *ngIf="!explorer" class="d-none d-md-flex justify-content-between row container-fluid mt-buttons">
<div class="d-flex">
      <div
        class="m-4">
        <button (click)="navigate('private')" class="app-button button-primary opacity-an transition-delay-3-5" style="width: 250px;"
          [ngClass]="{'animated':isAnimated}">
          <div>{{'START.START-PRIVATE' | translate}}</div>
        </button>
      </div>
      <div
        class="m-4">
        <button (click)="navigate('continue')" class="app-button button-secondery opacity-an transition-delay-3-5" style="width: 250px;"
          [ngClass]="{'animated':isAnimated}">
          <div class="px-4">{{'START.CONTINUE-PROCESS' | translate}}</div>
        </button>
      </div>
    </div>
      <div
        class="m-4">
        <button (click)="navigate('advisor')"
        class="app-button button-primary opacity-an transition-delay-3-5" style="width: 250px;"
        [ngClass]="{'animated':isAnimated}">
        <div>{{'START.START-ADVISOR'| translate}}</div>
      </button>
      </div>

    </div>


    <div class="d-md-none">
      <div *ngIf="!explorer" class="d-flex row container-fluid mt-buttons">
        <div
          class="d-flex justify-content-center justify-content-xl-end justify-content-md-end col-xl-6 col-md-6 col-sm-12 pr-xl-4 pr-lg-4 pr-md-4 mb-xl-0 mb-4">
  
          <button (click)="navigate('private')" class="app-button button-primary opacity-an transition-delay-3-5"
            [ngClass]="{'animated':isAnimated}">
            <div>{{'START.START-PRIVATE' | translate}}</div>
          </button>
        </div>
        <div
          class="d-flex justify-content-center justify-content-xl-start justify-content-md-start col-xl-6 col-md-6 col-sm-12 pr-xl-4 pr-lg-4 pr-md-4">
          <button (click)="navigate('continue')" class="app-button button-secondery opacity-an transition-delay-3-5"
            [ngClass]="{'animated':isAnimated}">
            <div class="px-4">{{'START.CONTINUE-PROCESS' | translate}}</div>
          </button>
        </div>
        <div
        class="mt-4 d-flex justify-content-center justify-content-xl-start justify-content-md-start col-xl-6 col-md-6 col-sm-12 pr-xl-4 pr-lg-4 pr-md-4">
        <button (click)="navigate('advisor')"
        class="app-button button-primary opacity-an transition-delay-3-5" style="width: 250px;"
        [ngClass]="{'animated':isAnimated}">
        <div>{{'START.START-ADVISOR'| translate}}</div>
      </button>
      </div>
      </div>
    </div>
    <a href="https://sc.mizrahi-tefahot.co.il/CycleMashkantaClient/"
      class="app-link c-drak app-text-decoration app-title-small-bold mt-3 opacity-an transition-delay-3-5"
      [ngClass]="{'animated':isAnimated}">
      {{'START.CYCLE-LINK' |translate}}</a>
    <inner-tooltip [qTitle]="'START.LINK_TOOLTIP'|translate" [text]="'START.TOOLTIP_TEXT'|translate"
      class="m-start-tooltip app-title-small-blue">
    </inner-tooltip>
  </div>
</div>

<div class="container my-5">
  <div class="d-flex flex-column flex-md-row">
    <div class="d-flex col-md-4 col-12 pr-md-5 pb-3 align-items-center opacity-an transition-delay-4"
      [ngClass]="{'animated':isAnimated}">
      <!-- <div class="lead-img mx-2 mb-2"></div> -->
      <img class="mx-2 lead-img" src="assets/images/check-list.png" alt="{{'START.LEAD1_ALT' | translate}}">
      <div class="w-75">
        <h5>{{'START.LEAD1' | translate}}</h5>
      </div>
    </div>
    <div class="d-flex col-md-4 col-12 pr-md-5 pb-3 align-items-center opacity-an transition-delay-5"
      [ngClass]="{'animated':isAnimated}">
      <!-- <div class="lead-img mx-2 mb-2"></div> -->
      <img class="mx-2 lead-img" src="assets/images/clock.png" alt="{{'START.LEAD2_ALT' | translate}}">
      <div class="w-75 w-md-50">
        <h5>{{'START.LEAD2' | translate}}</h5>
      </div>
    </div>
    <div class="d-flex col-md-4 col-12 pb-3 align-items-center opacity-an transition-delay-5-5"
      [ngClass]="{'animated':isAnimated}">
      <!-- <div class="lead-img mx-2 mb-2"></div> -->
      <img class="mx-2 lead-img" src="assets/images/home.png" alt="{{'START.LEAD3_ALT' | translate}}">
      <div class="w-75">
        <h5>{{'START.LEAD3' | translate}}</h5>
      </div>
    </div>
  </div>
</div>

<div class="container my-5">
</div>

<div
  class="goToLeft container text-center align-items-center d-flex flex-column flex-xl-row flex-md-column flex-lg-column text-md-center mb-3 opacity-an transition-delay-3-5"
  [ngClass]="{'animated':isAnimated}">

  <div class="col col-xl-6 col-md-12 m-start-card w-100 mb-4">
    <h3 class="my-2 app-title-xxlarge">{{'START.NEEDS' | translate}}</h3>
    <img class="mx-2 home-img" src="assets/app-images/icons/icons-48-px-home@3x.png"
      alt="{{'START.NEEDS' | translate}}">
    <div class="col px-xl-4 mx-auto">
      <h4 class="mt-2 app-title-midi">{{'START.NEEDS1' | translate}}</h4>
      <p class="app-title-small-blue">{{'START.NEEDS2' | translate}}</p>
      <img class="mx-2 user-img" src="assets/app-images/icons/icons-48-px-user@3x.png"
        alt="{{'START.NEEDS' | translate}}">
      <h4 class="mt-2 app-title-midi">{{'START.NEEDS3' | translate}}</h4>
      <p class="app-title-small-blue">{{'START.NEEDS4' | translate}}</p>
    </div>
  </div>

  <div class="mx-3 my-md-3 my-sm-3 my-xs-3"></div>

  <div class="col col-xl-6 col-md-12 m-start-card w-100 mb-4">
    <h3 class="my-2 app-title-xxlarge">{{'START.RECEIVES' | translate}}</h3>
    <img class="mx-2 document-img" src="assets/app-images/icons/icons-48-px-document@3x.png"
      alt="{{'START.NEEDS' | translate}}">
    <div class="px-xl-4 w-md-75 w-100 mx-auto">
      <h4 class="mt-2 app-title-midi">{{'START.RECEIVES1' | translate}}</h4>
      <p class="app-title-small-blue">{{'START.RECEIVES2-1' | translate}}</p>
      <img class="mx-2 approved-img" src="assets/app-images/icons/icons-48-px-approved@3x.png"
        alt="{{'START.NEEDS' | translate}}">
      <h4 class="mt-2 app-title-midi">{{'START.RECEIVES3' | translate}}</h4>
      <p class="app-title-small-blue">{{'START.RECEIVES4' | translate}}</p>
    </div>

  </div>
</div>

<div *ngIf="isDevMode">
  <app-playground></app-playground>
</div>


// WEBPACK FOOTER //
// ./src/app/start-page/start-page.component.html